const compact = (obj: object) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => {
      return !!value;
    })
  );
};

export default compact;
